import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDoctorFemale = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.9783 17.855C17.9508 17.6912 18.8997 17.4097 19.8042 17.0167C20.1034 16.8822 20.3377 16.6355 20.4567 16.3298C20.5756 16.0241 20.5696 15.6838 20.44 15.3825L19.2933 12.7067C19.0933 12.2401 18.9901 11.7377 18.99 11.23V9.5C18.99 7.67664 18.2657 5.92795 16.9764 4.63864C15.687 3.34933 13.9384 2.625 12.115 2.625C10.2916 2.625 8.54295 3.34933 7.25364 4.63864C5.96432 5.92795 5.24 7.67664 5.24 9.5V11.23C5.23988 11.7377 5.13669 12.2401 4.93666 12.7067L3.79 15.3825C3.66035 15.6838 3.65435 16.0241 3.7733 16.3298C3.89225 16.6355 4.12662 16.8822 4.42583 17.0167C5.32974 17.4096 6.2781 17.6911 7.25 17.855"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0117 21.375C19.3041 19.8793 18.1862 18.6153 16.7883 17.7302C15.3903 16.845 13.7697 16.3751 12.1151 16.3751C10.4604 16.3751 8.8398 16.845 7.44183 17.7302C6.04385 18.6153 4.926 19.8793 4.21838 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.115 6.375C12.115 6.375 10.9167 9.3725 7.92249 9.49583C7.72773 10.1488 7.6882 10.8383 7.80705 11.5093C7.9259 12.1803 8.19985 12.8143 8.60705 13.3606C9.01426 13.907 9.54347 14.3507 10.1525 14.6564C10.7615 14.9621 11.4336 15.1213 12.115 15.1213C12.7964 15.1213 13.4684 14.9621 14.0775 14.6564C14.6865 14.3507 15.2157 13.907 15.6229 13.3606C16.0301 12.8143 16.3041 12.1803 16.4229 11.5093C16.5418 10.8383 16.5023 10.1488 16.3075 9.49583C13.31 9.3725 12.115 6.375 12.115 6.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98999 20.125H11.49"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.24 18.875V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.99 21.375V16.5767"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDoctorFemale.displayName = 'SvgDoctorFemale';
export default SvgDoctorFemale;
